<template>

  <div class="request-transfer-stock-slips">
     <Loader
      v-if="loaderEnabled"
      v-bind:logo="loaderLogo"
    ></Loader
    >
    <div class="row">

      <div class="col-md-12">
         <KTCodePreview v-bind:title="'Danh sách phiếu yêu cầu chuyển kho'"
          > <template v-slot:toolbar
            >
            <div class="row">

              <div>
                 <b-dropdown
                  size="sm"
                  id="dropdown-1"
                  right
                  > <template slot="button-content"
                    > <i
                      style="font-size: 1rem"
                      class="fas fa-cog"
                    ></i
                    > <span class="font-weight-bolder">Thao tác</span> </template
                  > <b-dropdown-item @click="reportClick"
                    > <span
                      > <i
                        style="font-size: 1rem"
                        class="far fa-file-excel"
                      ></i
                      > &nbsp; Xuất Excel</span
                    > </b-dropdown-item
                  > </b-dropdown
                >
              </div>

              <div
                v-if="checkPermission('STOCK_TRANSFER_REQUEST_INSERT')"
                class="ml-3"
              >
                 <router-link to="/request-transfer/add-request-transfer"
                  > <b-button
                    v-bind:style="btnCreate"
                    variant="primary"
                    size="sm"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-add-1"
                    ></i
                    >Thêm mới </b-button
                  > </router-link
                >
              </div>

            </div>
             </template
          > <template v-slot:preview
            > <!-- Header session --> <b-row class="mb-5"
              > <b-col
                >
                <div class="d-flex justify-content-center align-items-center">
                   <date-picker
                    placeholder="Từ ngày"
                    class="form-control-sm"
                    :config="dpConfigs.start"
                    v-model="dpForm.startDate"
                  ></date-picker
                  > <span class="mr-1 ml-1"></span> <date-picker
                    placeholder="Đến ngày"
                    class="form-control-sm"
                    :config="dpConfigs.end"
                    v-model="dpForm.endDate"
                  ></date-picker
                  >
                </div>
                 </b-col
              > <b-col
                > <Autosuggest
                  :model="searchProduct"
                  :suggestions="filteredOptionsProduct"
                  placeholder="mã, tên, mã vạch sản phẩm"
                  :limit="10"
                  @select="onSelectedProduct"
                  @change="onInputChangeProduct"
                  suggestionName="productName"
                /> </b-col
              > <b-col
                > <Autosuggest
                  :model="filterParams.sourceWarehouseName"
                  :suggestions="filteredOptions"
                  placeholder="kho chuyển"
                  :limit="10"
                  @select="onSelectedSource"
                  @change="onInputChangeSource"
                  suggestionName="name"
                /> </b-col
              > <b-col
                > <Autosuggest
                  :model="filterParams.destinationWarehouseName"
                  :suggestions="filteredDStockOptions"
                  placeholder="kho nhận"
                  :limit="10"
                  @select="onDestinationSelected"
                  @change="onSearchDestinationChange"
                  suggestionName="name"
                /> </b-col
              > </b-row
            > <b-row class="mb-5"
              > <b-col
                > <b-form-input
                  v-model="filterParams.searchCode"
                  type="text"
                  placeholder="Mã phiếu"
                  size="sm"
                  v-on:keyup.enter="onFilter()"
                ></b-form-input
                > </b-col
              > <b-col
                > <b-form-input
                  v-model="filterParams.searchDesciption"
                  type="text"
                  placeholder="Tìm kiếm theo nội dung"
                  size="sm"
                  v-on:keyup.enter="onFilter()"
                ></b-form-input
                > </b-col
              > <b-col
                > <b-form-select
                  class="select-style"
                  size="sm"
                  v-model="selectedStatus"
                  :options="optionTransferStatus"
                  value-field="id"
                  text-field="name"
                ></b-form-select
                > </b-col
              > <b-col></b-col> </b-row
            > <b-row class="mb-5"
              > <b-col md="1"
                > <b-button
                  style="font-weight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="onFilter"
                  :disabled="onLoading === true"
                  >Lọc</b-button
                > </b-col
              > </b-row
            > <!-- End of Header session --> <!-- Table session --> <b-table
              :items="stockSlips"
              :fields="fields"
              sort-by="count"
              class="table-bordered table-hover col-md-12"
              :busy="onLoading"
              > <template v-slot:table-busy
                > <vcl-table
                  :speed="5"
                  :animate="true"
                  :columns="10"
                ></vcl-table
                > </template
              > <template v-slot:cell(count)="row"
                >
                <div style="text-align: center">
                   <span
                    v-text="row.item.count"
                    class="text-right"
                  ></span
                  >
                </div>
                 </template
              > <template v-slot:cell(code)="row"
                >
                <div
                  class="productCode"
                  @click="editItem(row.item)"
                  style="cursor: pointer"
                >
                   <span v-text="row.item.code"></span>
                </div>

                <div
                  v-if="row.item.relatedStockSlipCode"
                  class="text-success"
                >
                   <span>Phiếu chuyển:</span> <br /> <span style="font-size: 12px">{{
                    row.item.relatedStockSlipCode
                  }}</span
                  >
                </div>

                <p class="text-primary">{{ row.item.createdAt }}</p>
                 </template
              > <template v-slot:cell(warehouses)="row"
                >
                <div class="warehouse-transfer-cell">

                  <div class="warehouse-source">
                     <span class="font-weight-bolder text-primary"
                      > {{ row.item.sourceWarehouseName }} </span
                    >
                  </div>

                  <div class="warehouse-destination">
                     <span class="font-weight-bolder text-success"
                      > {{ row.item.destinationWarehouseName }} </span
                    >
                  </div>

                </div>
                 </template
              > <template v-slot:cell(status)="row"
                >
                <div class="status-cell-wrapper">

                  <div
                    class="status-badge-modern"
                    v-bind:class="getStatusColorClass(row.item.status)"
                  >
                     <i
                      :class="getStatusIcon(row.item.status)"
                      class="status-icon"
                    ></i
                    > <span class="status-text">{{ row.item.statusName }}</span
                    >
                  </div>

                  <p
                    class="status-date"
                    v-if="row.item.status === 2"
                  >
                     <i class="far fa-clock mr-1"></i> {{ row.item.approveDate }}
                  </p>

                </div>
                 </template
              > <template v-slot:cell(description)="row"
                >
                <div
                  @mouseover="hoverPrice = true"
                  @mouseleave="hoverPrice = false"
                >
                   <span
                    v-text="row.item.description"
                    class="mr-2"
                  ></span
                  > <span @click="handleShowNoteModel(row.item)"
                    > <i
                      v-if="hoverPrice"
                      class="fas fa-edit"
                    ></i
                    > </span
                  >
                </div>
                 </template
              > <template v-slot:cell(countProduct)="row"
                >
                <div style="text-align: right">
                   <span
                    v-text="convertPrice(row.item.countProduct)"
                    class="text-right"
                  ></span
                  >
                </div>
                 </template
              > <template v-slot:cell(countQuantity)="row"
                >
                <div style="text-align: right">
                   <span
                    v-text="convertPrice(row.item.countQuantity)"
                    class="text-right"
                  ></span
                  >
                </div>
                 </template
              > <template v-slot:cell(actions)="row"
                >
                <div class="d-flex justify-content-center">
                   <b-dropdown
                    size="sm"
                    id="dropdown-left"
                    no-caret
                    right
                    > <template slot="button-content"
                      > <i
                        style="font-size: 1rem; padding-right: 0px"
                        class="flaticon2-settings"
                      ></i
                      > </template
                    > <template
                      > <b-dropdown-item @click="printItem(row.item)"
                        > <span style="color: #3f4254; font-size: 12px"
                          > <i
                            style="font-size: 1rem"
                            class="flaticon2-printer"
                          ></i
                          > &nbsp; In phiếu </span
                        > </b-dropdown-item
                      > <b-dropdown-item
                        @click="createTransfer(row.item)"
                        v-if="isCanApprove(row.item)"
                        > <span cstyle="color: #3f4254; font-size: 12px"
                          > <i
                            style="font-size: 1rem"
                            class="fa fa-plus"
                          ></i
                          > &nbsp; Tạo phiếu chuyển </span
                        > </b-dropdown-item
                      > <b-dropdown-item
                        @click="showWarningAlert(row.item)"
                        v-if="isShowCancelRequest(row.item.status)"
                        > <span class="color: #3f4254; font-size: 12px"
                          > <i
                            style="font-size: 1rem"
                            class="flaticon2-reply-1"
                          ></i
                          > &nbsp; Hủy phiếu </span
                        > </b-dropdown-item
                      > <b-dropdown-item @click="editItem(row.item)"
                        > <span style="color: #3f4254; font-size: 12px"
                          > <i
                            style="font-size: 1rem"
                            class="flaticon2-pen"
                          ></i
                          > &nbsp; Chỉnh sửa </span
                        > </b-dropdown-item
                      > <b-dropdown-item
                        @click="showDeleteAlert(row.item)"
                        v-if="checkPermission('STOCK_TRANSFER_REQUEST_DELETE')"
                        > <span style="color: #3f4254; font-size: 12px"
                          > <i
                            style="font-size: 1rem; color: #d33"
                            class="flaticon2-rubbish-bin-delete-button"
                          ></i
                          > &nbsp; Xóa </span
                        > </b-dropdown-item
                      > </template
                    > </b-dropdown
                  >
                </div>
                 </template
              > </b-table
            > <!-- End of Table session --> <!-- Paginate session --> <b-row
              > <b-col
                >
                <p
                  class="mt-3 text-dark"
                  style="font-weight: 500"
                >
                   Tổng: {{ totalItems }}
                </p>
                 </b-col
              > <b-col
                > <b-pagination-nav
                  class="custom-pagination"
                  v-show="numberOfPage >= 2"
                  :link-gen="linkGen"
                  :number-of-pages="numberOfPage"
                  use-router
                  @change="fetchStockSlip"
                  align="right"
                  first-class="page-item-first btn btn-icon btn-sm m-1"
                  prev-class="page-item-prev btn btn-icon btn-sm m-1"
                  next-class="page-item-next btn btn-icon btn-sm m-1 "
                  last-class="page-item-last btn btn-icon btn-sm m-1 "
                  page-class="btn btn-icon btn-sm border-0 m-1"
                  > <template v-slot:first-text
                    > <span> <i class="ki ki-bold-double-arrow-back icon-xs"></i> </span> </template
                  > <template v-slot:prev-text
                    > <i class="ki ki-bold-arrow-back icon-xs"></i> </template
                  > <template v-slot:next-text
                    > <i class="ki ki-bold-arrow-next icon-xs"></i> </template
                  > <template v-slot:last-text
                    > <span class="text-info"
                      > <i class="ki ki-bold-double-arrow-next icon-xs"></i> </span
                    > </template
                  > </b-pagination-nav
                > </b-col
              > </b-row
            > <!-- End of Paginate session --> <template
              > <b-modal
                v-model="showEditNoteModal"
                hide-footer
                :title="'Sửa ghi chú cho phiếu: ' + stockSlipCode"
                > <b-row class="mb-5"
                  > <b-col
                    > <label
                      class="labelInput"
                      for="inputOriginalPrice"
                      >Ghi chú</label
                    > <b-form-textarea
                      v-model="note"
                      placeholder="Nhập ghi chú..."
                      rows="5"
                      max-rows="6"
                    ></b-form-textarea
                    > </b-col
                  > </b-row
                > <b-row
                  > <b-col
                    > <b-button
                      style="font-weight: 600; width: 70px"
                      variant="primary"
                      size="sm"
                      @click="updateNote"
                      >Lưu</b-button
                    > <b-button
                      style="margin-left: 10px; font-weight: 600; width: 70px"
                      variant="secondary"
                      size="sm"
                      @click="handleShowNoteModel"
                      >Hủy</b-button
                    > </b-col
                  > </b-row
                > </b-modal
              > </template
            > </template
          > </KTCodePreview
        >
      </div>

    </div>

  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import ApiService from '@/core/services/api.service'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import moment from 'moment'
  import { TRANSFER_STOCK } from '@/utils/constants'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import { VclTable } from 'vue-content-loading'
  import Swal from 'sweetalert2'
  import axios from 'axios'
  import decounce from 'debounce'
  import localData, { checkPermissions } from '@/utils/saveDataToLocal'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import { STOCK_SLIP_RELATION_TYPE, STOCK_SLIP_STATUS, STOCK_SLIP_TYPE } from '@/utils/enum'
  import { STOCK_SLIP_STATUS_NAME } from '@/utils/enum-name'
  import fileDownload from '@/utils/file-download'
  import { BASE_URL } from '@/utils/constants'
  import {
    makeToastSuccess,
    makeToastFaile,
    removeAccents,
    xoa_dau,
    cloneDeep,
    convertPrice,
    handleError,
  } from '@/utils/common'
  import { mapGetters } from 'vuex'
  import Loader from '@/view/content/Loader.vue'

  export default {
    data() {
      return {
        dpForm: {
          startDate: moment().subtract(15, 'days').format('DD/MM/YYYY'),
          endDate: '',
        },
        dpConfigs: {
          start: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
          end: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        onLoading: false,
        language: vi,
        btnCreate: {
          fontWeight: '600!important',
        },
        stockSlips: [],
        currentPage: 0,
        numberOfPage: 0,
        count: 1,
        totalItems: 0,
        page: 1,
        status: '',
        store: '',
        searchFromDay: '',
        searchToDay: '',
        type: TRANSFER_STOCK,
        selectedStatus: null,
        searchCreatedBy: '',
        filteredOptionsOriginal: [],
        searchQuery: null,
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: {
              textAlign: 'center',
              fontWeight: 600,
              color: '#181c32',
              width: '6%',
            },
            tdClass: 'sttClass',
          },
          {
            key: 'code',
            label: 'Mã phiếu chuyển kho',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '14%' },
          },
          {
            key: 'warehouses',
            label: 'Kho chuyển → Kho nhận',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          },
          {
            key: 'description',
            label: 'Nội dung',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          },
          {
            key: 'countProduct',
            label: 'SL SP',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          },
          {
            key: 'countQuantity',
            label: 'Tổng SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          },
          {
            key: 'status',
            label: 'Trạng thái',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'statusProClass',
            thClass: 'statusProClass',
          },
          {
            key: 'createBy',
            label: 'Người tạo',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          },
          { key: 'actions', label: '', thStyle: { width: '5%' } },
        ],
        linkGen: (pageNum) => {
          return pageNum === 1 ? '?' : `?page=${pageNum}`
        },
        selected: '',
        sourceWarehouses: [],
        filteredOptions: [],
        limit: 10,
        selectedDStock: '',
        destinationWarehouses: [],
        filteredDStockOptions: [],
        searchProduct: '',
        filteredOptionsProduct: [],
        optionsProduct: [
          {
            data: [],
          },
        ],
        hoverPrice: false,
        stockSlipCode: '',
        showEditNoteModal: false,
        note: '',
        optionTransferStatus: [
          {
            id: null,
            name: 'Chọn trạng thái',
          },
          {
            id: STOCK_SLIP_STATUS.NEW,
            name: STOCK_SLIP_STATUS_NAME[STOCK_SLIP_STATUS.NEW],
          },
          {
            id: STOCK_SLIP_STATUS.CONFIRMED,
            name: STOCK_SLIP_STATUS_NAME[STOCK_SLIP_STATUS.CONFIRMED],
          },
          {
            id: STOCK_SLIP_STATUS.CANCELD,
            name: STOCK_SLIP_STATUS_NAME[STOCK_SLIP_STATUS.CANCELD],
          },
        ],
        STOCK_SLIP_RELATION_TYPE,
        filterParams: {
          page: 1,
          limit: 10,
          searchCode: '',
          searchDesciption: '',
          sourceWarehouseName: '',
          sourceWarehouseId: null,
          destinationWarehouseName: '',
          destinationWarehouseId: null,
        },
      }
    },
    methods: {
      convertPrice,
      sendParams(data) {
        this.dpForm.startDate = data.searchFromDate
        this.fetchStockSlip()
      },
      checkPermissions,
      fetchStore: async function () {
        this.filteredOptions = []
        ApiService.get('v1/stores/all').then((response) => {
          this.sourceWarehouses = response.data.data
          this.destinationWarehouses = response.data.data
          this.filteredOptions = [...this.sourceWarehouses]
          this.filteredDStockOptions = [...this.destinationWarehouses]
        })
      },
      fetchStockSlip: async function () {
        if (this.onLoading) return
        this.onLoading = true
        this.filterParams.page = this.$route.query.page
        if (!this.filterParams.page) {
          this.filterParams.page = 1
        }
        const params = {
          page: this.filterParams.page || 1,
          limit: this.filterParams.limit || 10,
          searchDesciption: this.filterParams.searchDesciption
            ? this.filterParams.searchDesciption.trim()
            : '',
          searchCode: this.filterParams.searchCode ? this.filterParams.searchCode.trim() : '',
          searchFromDay: this.dpForm.startDate
            ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : '',
          searchToDay: this.dpForm.endDate
            ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : '',
          sourceWarehouseId:
            this.filterParams.sourceWarehouseId && this.filterParams.sourceWarehouseName
              ? this.filterParams.sourceWarehouseId
              : null,
          destinationWarehouseId:
            this.filterParams.destinationWarehouseId && this.filterParams.destinationWarehouseName
              ? this.filterParams.destinationWarehouseId
              : null,
          searchProduct: this.searchProduct,
          searchEmployeeId: this.searchCreatedBy,
          status: this.selectedStatus,
        }
        ApiService.query('v1/transfer-stock-slips/request', { params })
          .then((response) => {
            this.stockSlips = []
            const stockResponse = response.data.data.data
            this.numberOfPage = response.data.data.totalPage
            this.currentPage = response.data.data.currentPage
            this.totalItems = response.data.data.totalRow
            let result = []
            stockResponse.forEach((item, index) => {
              const stock = {
                ...item,
                count: this.currentPage >= 2 ? index + 1 + this.currentPage * 10 - 10 : index + 1,
                createdAt: moment(item.createdAt).format('HH:mm:ss DD/MM/YYYY'),
                approveDate: moment(item.approveDate).format('HH:mm:ss DD/MM/YYYY'),
              }
              result.push(stock)
              this.stockSlips = [...new Set(result)]
            })
            this.onLoading = false
          })
          .catch((err) => {
            this.onLoading = false
            this.stockSlips = []
            this.totalItems = 0
            this.numberOfPage = 0
            handleError(err)
          })
      },
      editItem: function (item) {
        this.$router.push({
          name: 'edit-request-transfer',
          query: { id: item.id },
        })
      },
      onDestinationSelected(option) {
        this.filterParams.destinationWarehouseName = option.item.name
        this.filterParams.destinationWarehouseId = option.item.id
      },
      onSearchDestinationChange(text) {
        this.filterParams.destinationWarehouseName = ''
        if (!text) {
          text = ''
        }
        this.filterParams.destinationWarehouseName = text

        const filteredData = this.destinationWarehouses
          .filter((item) => {
            return (
              item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, this.limit)

        this.filteredDStockOptions = [...filteredData]
      },
      onSelectedSource(option) {
        this.filterParams.sourceWarehouseName = option.item.name
        this.filterParams.sourceWarehouseId = option.item.id
      },
      onInputChangeSource(text) {
        this.filterParams.sourceWarehouseName = ''
        if (!text) {
          text = ''
        }
        this.filterParams.sourceWarehouseName = text

        const filteredData = this.sourceWarehouses
          .filter((item) => {
            return (
              item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, this.limit)

        this.filteredOptions = [...filteredData]
      },
      showDeleteAlert: function (item) {
        Swal.fire({
          title: 'Xóa phiếu yêu cầu!',
          text: 'Bạn có chắc muốn xóa phiếu yêu cầu chuyển kho này không ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }).then((result) => {
          if (result.value) {
            this.deleteItem(item)
          }
        })
      },
      showWarningAlert: function (item) {
        const title = 'Hủy phiếu yêu cầu chuyển kho!'
        const text = 'Bạn có chắc muốn hủy phiếu yêu cầu chuyển kho này?'
        const confirmText = 'Đồng ý'
        const optionsNotify = {
          title,
          text,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: confirmText,
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }
        Swal.fire(optionsNotify).then((result) => {
          if (result.value) {
            this.cancelRequest(item)
          }
        })
      },
      cancelRequest: async function (item) {
        ApiService.put(`v1/transfer-stock-slips/${item.id}/cancel-transfer-request`).then(
          ({ data }) => {
            makeToastSuccess(data.message)
            this.fetchStockSlip()
          },
        )
      },
      deleteItem: async function (item) {
        ApiService.delete(`v1/transfer-stock-slips/${item.id}`).then(({ data }) => {
          makeToastSuccess(data.message)
          this.fetchStockSlip()
        })
      },
      fetchProduct() {
        this.optionsProduct[0].data = []
        ApiService.get(`products/searchProductByName?name=${this.searchProduct}`).then(
          ({ data }) => {
            const products = data.data
            products.map((element) => {
              this.optionsProduct[0].data.push(element)
            })
            this.filteredOptionsProduct = [...this.optionsProduct[0].data]
            this.fetchStockSlip()
          },
        )
      },
      debounceInput: decounce(function () {
        this.fetchProduct()
      }, 500),
      onSelectedProduct(option) {
        this.searchProduct = option.item.productName
      },
      onInputChangeProduct(text) {
        if (!text) {
          text = ''
        }
        this.searchProduct = text
        this.debounceInput()
      },
      onFilter() {
        this.$route.query.page = 1
        this.$router.push({
          name: 'list-request-transfer',
        })
        this.fetchStockSlip()
      },
      checkPermission: function (condition) {
        return localData.checkPermission(condition)
      },
      handleShowNoteModel(item) {
        this.showEditNoteModal = !this.showEditNoteModal
        this.stockSlipCode = item.code
        this.note = item.description
      },
      updateNote() {
        const data = {
          stockSlipCode: this.stockSlipCode,
          description: this.note,
        }
        ApiService.put('v1/stock-slips/note', data)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            this.showEditNoteModal = !this.showEditNoteModal
            this.fetchStockSlip()
          })
          .catch(({ response }) => {
            makeToastFaile(response.$error)
          })
      },
      async fetchEmployees() {
        try {
          const params = {
            orderBy: ['createdAt', 'DESC'],
          }
          const response = await ApiService.query('employees/getAll', params)
          const employees = response.data.data || []
          const employeeOptions = employees.map((item) => {
            const { id, fullName, code, email } = item
            const nameNoneSign = xoa_dau(fullName)
            return {
              id,
              code,
              email,
              fullName: nameNoneSign,
              nameNoneSign: nameNoneSign,
            }
          })
          this.filteredOptionsOriginal = employeeOptions
        } catch (err) {
          console.log('err::: ', err)
        }
      },
      getStatusColor(status) {
        const MAP_COLOR = {
          1: 'label-light-warning',
          2: 'label-light-success',
          3: 'label-light-danger',
          4: 'label-light-default',
        }

        return MAP_COLOR[status] || 'label-light-default'
      },
      getStatusColorClass(status) {
        const MAP_COLOR = {
          1: 'status-new',
          2: 'status-approved',
          3: 'status-confirmed',
          4: 'status-cancelled',
        }

        return MAP_COLOR[status] || 'status-cancelled'
      },
      getStatusIcon(status) {
        const MAP_ICON = {
          1: 'fas fa-circle-notch',
          2: 'fas fa-check-circle',
          3: 'fas fa-check-double',
          4: 'fas fa-times-circle',
        }

        return MAP_ICON[status] || 'fas fa-circle'
      },
      isCanApprove(rowItem) {
        return rowItem.status === STOCK_SLIP_STATUS.NEW
      },
      createTransfer(rowItem) {
        this.$router.push({
          name: 'add-inventory-transfer',
          query: { requestTransferId: rowItem.id },
        })
      },
      confirmTransfer(rowItem) {
        this.$router.push({
          name: 'confirm-inventory-transfer',
          query: { id: rowItem.id },
        })
      },
      isShowCancelRequest(stockSlipStaus) {
        return stockSlipStaus === STOCK_SLIP_STATUS.NEW
      },
      reportClick: async function () {
        const params = {
          type: STOCK_SLIP_TYPE.REQUEST_TRANSFER,
          searchDesciption: this.filterParams.searchDesciption
            ? this.filterParams.searchDesciption.trim()
            : '',
          searchCode: this.filterParams.searchCode ? this.filterParams.searchCode.trim() : '',
          searchFromDay: this.dpForm.startDate
            ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : '',
          searchToDay: this.dpForm.endDate
            ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : '',
          sourceWarehouseId:
            this.filterParams.sourceWarehouseId && this.filterParams.sourceWarehouseName
              ? this.filterParams.sourceWarehouseId
              : null,
          destinationWarehouseId:
            this.filterParams.destinationWarehouseId && this.filterParams.destinationWarehouseName
              ? this.filterParams.destinationWarehouseId
              : null,
          searchProduct: this.searchProduct,
          status: this.selectedStatus,
        }
        // Remove null, undefined, or empty string values
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''),
        )
        const queryString = new URLSearchParams(filteredParams).toString()
        const baseUrl = BASE_URL
        const url = `${baseUrl}v1/transfer-stock-slips/export-excel-stock-slip?${queryString}`

        await axios({
          url: url,
          method: 'GET',
          responseType: 'blob',
          onDownloadProgress: function (progressEvent) {
            console.log(progressEvent)
          },
        }).then((response) => {
          const fileName = fileDownload.getFileName(response)
          fileDownload.createFile(response.data, fileName)
        }).catch(async (err) => {
          try {
            const text = await err.response?.data?.text()
            const json = JSON.parse(text)
            err.response.data = json
          } catch (_) {}
          handleError(err)
        })
      },
      printItem(item) {
        this.$router.push({
          name: 'print-inventory-transfer',
          query: { id: item.id },
        })
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Chuyển kho', route: 'inventory-transfer' },
        { title: 'Danh sách phiếu chuyển kho' },
      ])
    },
    created() {
      this.fetchStockSlip()
      this.fetchStore()
      // this.fetchEmployees();
    },
    computed: {
      ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
      loaderEnabled() {
        return !/false/.test(this.layoutConfig('loader.type'))
      },
      loaderLogo() {
        return this.layoutConfig('loader.logo')
      },
      resultQuery() {
        if (this.searchQuery) {
          return cloneDeep(this.filteredOptionsOriginal).filter((item) => {
            return (
              removeAccents(item.fullName)
                .toLowerCase()
                .indexOf(removeAccents(this.searchQuery.toLowerCase())) > -1
            )
          })
        } else {
          return this.filteredOptionsOriginal
        }
      },
    },
    components: {
      KTCodePreview,
      Autosuggest,
      VclTable,
      Loader,
    },
  }
</script>

<style lang="scss">
  .request-transfer-stock-slips {
  .table th,
  .table td {
    padding: 0.25rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }

  .table td.statusProClass {
    overflow: visible !important;
    white-space: normal !important;
    min-width: 100px;
  }

  .status-cell-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.5rem 0.5rem;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .status-badge-modern {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    max-width: 100%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    transition: all 0.2s ease;
    border: 1px solid transparent;
  }

  .status-badge-modern:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }

  .status-icon {
    font-size: 0.75rem;
    flex-shrink: 0;
  }

  .status-text {
    white-space: normal;
    word-break: break-word;
    line-height: 1.3;
  }

  .status-new {
    background: #fff4de;
    color: #ffa800;
    border-color: #ffa800;
  }

  .status-new .status-icon {
    color: #ffa800;
    animation: pulse 2s infinite;
  }

  .status-approved {
    background: #c9f7f5;
    color: #1bc5bd;
    border-color: #1bc5bd;
  }

  .status-approved .status-icon {
    color: #1bc5bd;
  }

  .status-confirmed {
    background: #ffe2e5;
    color: #f64e60;
    border-color: #f64e60;
  }

  .status-confirmed .status-icon {
    color: #f64e60;
  }

  .status-cancelled {
    background: #e4e6ef;
    color: #7e8299;
    border-color: #7e8299;
  }

  .status-cancelled .status-icon {
    color: #7e8299;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }

  .status-date {
    margin: 0.25rem 0 0 0;
    font-size: 0.7rem;
    color: #6c757d;
    line-height: 1.2;
    font-weight: 400;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
  }

  .status-date i {
    font-size: 0.65rem;
  }

  .warehouse-transfer-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.25rem;
    padding: 0.5rem 0;
  }

  .warehouse-source,
  .warehouse-destination {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .example {
    border: 1px solid #ddd;
    margin-bottom: 2em;
  }

  code,
  pre {
    margin: 1em 0;
    padding: 1em;
    border: 1px solid #bbb;
    display: block;
    background: #ddd;
    border-radius: 3px;
  }

  .settings {
    margin: 2em 0;
    border-top: 1px solid #bbb;
    background: #eee;
  }

  .form-group {
    margin-bottom: 1em;
  }

  .btn.btn-icon.btn-sm,
  .btn-group-sm > .btn.btn-icon {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .sttClass {
    width: 20px;
  }

  .productCode:hover {
    text-decoration: underline;
  }

  .page-item.disabled {
    cursor: not-allowed;

    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>

